module.exports = __webpack_public_path__ + "images/1809f6952dedcd65defd886a8982d3ae.svg";